





































































































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';

import 'vue-select/dist/vue-select.css';
import VueApexCharts from 'vue-apexcharts';
import {
  AdmiralException,
  GoalValueType,
  IFivGoal,
  IFivGoalResult,
  IFivReport,
} from 'admiral-core';
import GoalAchievementChart from '@/views/pages/fivgoals/GoalAchievementChart.vue';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  InfoIcon,
  MoreVerticalIcon,
  MoveIcon,
  SettingsIcon,
} from 'vue-feather-icons';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { GoalApi } from '@/services/GoalApi';
import ContextMenu from '@/components/common/ContextMenu.vue';
import Avatar from '@/components/common/Avatar.vue';
import PolicyStatusBadge from '@/components/common/PolicyStatusBadge.vue';
import EditFivGoalModal from '@/views/pages/fivgoals/EditFivGoalModal.vue';

@Component({
  components: {
    EditFivGoalModal,
    Avatar,
    ContextMenu,
    SettingsIcon,
    MoveIcon,
    MoreVerticalIcon,
    GoalAchievementChart,
    apexchart: VueApexCharts,
    PolicyStatusBadge,
    ChevronDownIcon,
    ChevronUpIcon,
    InfoIcon,
  },
})
export default class FivGoalChart extends mixins(BaseMixin) {
  @Prop({ type: String })
  name!: string;

  @Prop({ type: Object })
  goal!: IFivGoal;

  @Prop({ type: String, default: () => 'bottom' })
  legendPosition!: string;

  @Prop({ type: String, default: () => 'sm' })
  size!: string;

  @Prop({ required: true, type: Object })
  report!: IFivReport;

  @Prop({ required: false, type: Boolean, default: () => false })
  isEh!: boolean;

  @Prop({ required: false, type: Boolean, default: () => true })
  hasHandle!: boolean;

  contextMenuVisible = false;
  showLeads = false;

  error: string | null = null;

  goalResult: Partial<IFivGoalResult> = {
    name: '',
    timeValue: 0,
    timeQuantity: 0,

    leadsValue: 0,
    leadsQuantity: 0,
    lastYearValue: 0,
    lastYearQuantity: 0,
    value: 0,
    quantity: 0,
    endValue: 0,
    // @ts-ignore
    goal: {
      name: '',
    },
  };

  max = 0;

  goalValuePercentage = 0;
  goalValueWithLeadsPercentage = 0;
  goalTimeValuePercentage = 0;
  goalTimeValueWithLeadsPercentage = 0;

  series: ApexAxisChartSeries = [];

  loading = false;

  get goalValueTypeValuation() {
    return this.goalResult?.goal?.valueType === GoalValueType.Valuation;
  }
  get goalValueTypeQuantity() {
    return this.goalResult?.goal?.valueType === GoalValueType.Quantity;
  }

  get result() {
    return this.goalValueTypeValuation ? this.goalResult.value : this.goalResult.quantity;
  }

  get goalProducts() {
    return this.goalResult ? this.goalResult?.goal?.products : [];
  }

  get valueType() {
    return this.goalValueTypeValuation ? 'Nach Bewertung' : 'Nach Stückzahl';
  }

  get submitted() {
    return this.goalValueTypeValuation
      ? this.goalResult!.submittedValue || 0
      : this.goalResult!.submittedQuantity || 0;
  }

  get open() {
    return this.goalValueTypeValuation
      ? this.goalResult!.openValue || 0
      : this.goalResult!.openQuantity || 0;
  }

  get leads() {
    return this.submitted + this.open;
  }

  get end() {
    return this.goalValueTypeValuation ? this.goalResult!.endValue : this.goalResult!.endQuantity;
  }

  get time() {
    return this.goalValueTypeValuation ? this.goalResult!.timeValue : this.goalResult!.timeQuantity;
  }

  get lastYear() {
    return this.goalValueTypeValuation
      ? this.goalResult!.lastYearValue
      : this.goalResult!.lastYearQuantity;
  }

  async loadResult() {
    try {
      this.loading = true;
      const result = await GoalApi.getFivGoalResult({
        goal: this.goal,
        goalGroup: this.report.goalGroup,
        report: this.report,
      });

      this.goalResult = result.data;

      this.goalValuePercentage = Math.round(
        // @ts-ignore
        (this.result / this.end) * 100,
      );

      this.goalValueWithLeadsPercentage = Math.round(
        // @ts-ignore
        ((this.result + this.leads) / this.end) * 100,
      );

      this.goalTimeValuePercentage = Math.round(
        // @ts-ignore
        (this.result / this.time) * 100,
      );

      this.goalTimeValueWithLeadsPercentage = Math.round(
        // @ts-ignore
        ((this.result + this.leads) / this.time) * 100,
      );
    } catch (e: any) {
      const exception = e.response?.data as AdmiralException;
      if (exception.errors) {
        const errors = exception.errors;
        if (errors['MissingGoal']) {
          this.error = 'Ziel nicht gefunden.';
        }
      }
    }
    this.loading = false;

    if (this.isEh) {
      this.chartOptions.xaxis.categories = ['', 'Ergebnis + Anbahnungen', ''];
      this.chartOptions.colors = [this.colors.result, this.colors.submitted, this.colors.open];

      this.series = [
        {
          // @ts-ignore
          name: `Ergebnis: ${this.result.toLocaleString('de-DE')}`,
          // @ts-ignore
          data: [0, this.result as number, 0],
        },
        {
          // @ts-ignore
          name: `Eingereicht: ${this.submitted.toLocaleString('de-DE')}`,

          // @ts-ignore
          data: [0, this.submitted, 0],
        },
        {
          // @ts-ignore
          name: `Offen: ${this.open.toLocaleString('de-DE')}`,

          // @ts-ignore
          data: [0, this.open, 0],
        },
      ];
    } else {
      this.chartOptions.xaxis.categories = [
        'VJ',
        this.size === 'lg' ? 'Ergebnis + Anbahnungen' : 'Erg. + Anb.',
        'Ziel',
      ];
      this.chartOptions.colors = [
        this.colors.lastYear,
        this.colors.result,
        this.colors.submitted,
        this.colors.open,
        this.colors.time,
      ];
      this.series = [
        {
          // @ts-ignore
          name: `Ergebnis VJ: ${this.lastYear.toLocaleString('de-DE')}`,
          // @ts-ignore
          data: [(this.lastYear as number) > 0 ? (this.lastYear as number) : 0, 0],
        },
        {
          // @ts-ignore
          name: `Ergebnis: ${this.result.toLocaleString('de-DE')}`,
          // @ts-ignore
          data: [0, this.result as number, 0],
        },
        {
          // @ts-ignore
          name: `Eingereicht: ${this.submitted.toLocaleString('de-DE')}`,

          // @ts-ignore
          data: [0, this.submitted, 0],
        },
        {
          // @ts-ignore
          name: `Offen: ${this.open.toLocaleString('de-DE')}`,

          // @ts-ignore
          data: [0, this.open, 0],
        },

        {
          // @ts-ignore
          name: `Zielwert: ${this.end.toLocaleString('de-DE')}`,
          // @ts-ignore
          data: [0, 0, this.end],
        },
      ];
    }

    const values = [
      this.end || 0,
      this.open || 0,
      this.submitted || 0,
      this.result || 0,
      this.time || 0,

      (this.result || 0) + (this.leads || 0),
      this.goalResult?.goal?.agencyValue || 0,
    ];
    values.push();

    this.max = Math.max(...values);

    const annotations: any = [
      {
        y: this.time,
        strokeDashArray: 3,
        borderColor: '#000',
        fillColor: '#000',
        opacity: 1,
        stroke: {
          width: [4],
        },
        label: {
          borderColor: '#000',
          offsetX: -6,
          offsetY: 6,
          style: {
            color: '#fff',
            background: '#000',
          },
          // @ts-ignore
          text: 'Zeitziel: ' + this.time.toLocaleString('de-DE') + '',
        },
      },
    ];

    if (this.isEh) {
      annotations.push({
        y: this.end,
        strokeDashArray: 0,
        borderColor: '#000',
        fillColor: '#000',
        opacity: 1,
        stroke: {
          width: [4],
        },
        label: {
          borderColor: '#000',
          offsetX: 6,
          offsetY: 6,
          position: 'left',
          textAnchor: 'start',
          style: {
            color: '#fff',
            background: '#000',
          },
          // @ts-ignore
          text: 'Eingangshürde: ' + this.end.toLocaleString('de-DE'),
        },
      });
    }

    if (this.goalResult?.goal?.agencyValue) {
      annotations.push({
        y: this.goalResult?.goal?.agencyValue,
        strokeDashArray: 0,
        borderColor: '#000',
        fillColor: '#000',
        opacity: 1,
        stroke: {
          width: [4],
        },
        label: {
          borderColor: '#000',
          offsetX: 6,
          offsetY: 6,
          position: 'left',
          textAnchor: 'start',
          style: {
            color: '#fff',
            background: '#000',
          },
          // @ts-ignore
          text: 'Agenturziel: ' + this.goalResult?.goal?.agencyValue.toLocaleString('de-DE'),
        },
      });
    }

    this.chartOptions = {
      ...this.chartOptions,
      yaxis: [
        {
          show: false,
          // @ts-ignore
          max: this.max * 1.1,
        },
      ],
      annotations: {
        yaxis: annotations,
      },
    };
  }

  async mounted() {
    await this.loadResult();
  }

  chartOptions: any = {
    chart: {
      type: 'bar',
      stacked: true,

      toolbar: {
        show: false,
      },
    },
    xaxis: {
      categories: ['VJ', this.size === 'lg' ? 'Ergebnis + Anbahnungen' : 'Erg. + Anb.', 'Ziel'],
      axisTicks: {
        show: true,
      },
      labels: {
        rotate: 0,
        rotateAlways: false,
      },
    },
    yaxis: [
      {
        show: false,
      },
    ],
    colors: [],
    grid: {
      show: true,
      borderColor: '#eeeeee',
      // padding: {
      //   top: -12,
      //   bottom: -12,
      // },
      padding: {
        top: 0,
        left: 0,
        right: 0,
      },
    },
    dataLabels: {
      enabled: false,
      style: {
        colors: ['#fff'],
        fontSize: '10px',
      },
      background: {
        enabled: false,
      },
      formatter: (val: number) => {
        return val.toLocaleString('de-DE');
      },
      offsetX: 0,
      offsetY: 0,
      textAnchor: 'middle',
    },
    plotOptions: {
      bar: {
        horizontal: false,
        dataLabels: {
          position: 'bottom',
        },
        borderRadius: 2,
        // columnWidth: '82%',
      },
    },
    tooltip: {
      fixed: {
        enabled: true,
        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
        offsetY: 30,
        offsetX: 60,
      },
      y: {
        formatter: (value: number) => value.toLocaleString('de-DE'),
        title: {
          formatter: (seriesName: string) => seriesName.replace(/[0-9.]/g, ''),
        },
      },
    },
    legend: {
      show: false,
      offsetX: -15,

      offsetY: 5,
      // position: this.legendPosition,
      horizontalAlign: 'left',
    },
  };
  editGoal() {
    this.contextMenuVisible = false;
    (this.$refs['edit-fiv-goal-modal'] as any).$refs['edit-fiv-goal'].show();
  }

  get relativeTime() {
    return (this.time! / this.end!) * 100;
  }

  get relativeResult() {
    return (this.result! / this.end!) * 100;
  }

  get relativeLeads() {
    return (this.leads! / this.end!) * 100;
  }
  get relativeForecast() {
    return (this.forecast! / this.end!) * 100;
  }

  get forecast() {
    return this.result! + this.leads!;
  }

  get colors() {
    return {
      lastYear: '#a2acbd',
      result: '#245a99',
      submitted: '#79b2f5',
      open: '#3A7BC7',
      time: '#013781',
    };
  }
}
